import { useQuery } from '@tanstack/react-query';
import { moodleQueryKeys } from '../all-query-keys';
import { getMyBlockingDecision } from '../../../services/MoodleService';

export const useGetMyBlockingDecision = ({ enabled = true } = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: moodleQueryKeys.getMyBlockingDecision(),
    queryFn: getMyBlockingDecision,
    enabled,
  });

  const blockingDecision = data?.data ?? null;
  return { blockingDecision, loading: isLoading };
};
